import React, { useState } from "react";
import _ from "lodash";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import NumberFormat from "react-number-format";
import { useFormikContext } from "formik";
import { Card, Table } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import { FormArrayTextField } from "../../../../partials/content/Forms/FormField";
import { DialogActions, Typography } from "@material-ui/core";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchCostComponent from "../../setup/sales/cost-component/searchCostComponent";

function SalesAdditionalCost({ property = "", calculateTotalPrice }) {
  const { values, setFieldValue } = useFormikContext();
  const [itemIndex, setItemIndex] = useState(0);
  const [openSearchCostComp, setOpenSearchCostComp] = useState(false);
  return (
    <React.Fragment>
      <Card>
        <Card.Body className="py-0">
          <Table borderless size="sm" responsive="xl">
            <thead className="text-center">
              {values[property] && values[property].length > 0 ? (
                <tr>
                  <th style={{ width: "55%" }}>Cost Name</th>
                  <th style={{ width: "40%" }}>Cost Price</th>
                  <th>Actions</th>
                </tr>
              ) : null}
            </thead>
            <tbody>
              {values[property] && values[property].length > 0 ? (
                values[property].map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <FormArrayTextField
                          arrayPropName={property}
                          index={index}
                          margin="none"
                          propName="itemName"
                          readonly
                          searchButton
                          onSearchClick={() => {
                            setItemIndex(index);
                            setOpenSearchCostComp(true);
                          }}
                        />
                      </td>
                      <td>
                        <FormArrayTextField
                          arrayPropName={property}
                          index={index}
                          margin="none"
                          propName="costPrice"
                          currencyField
                          currencyCode={values.currencyCode}
                          onBlur={() => {
                            calculateTotalPrice(-1, -1, false);
                          }}
                        />
                      </td>
                      <td
                        style={{ whiteSpace: "nowrap" }}
                        className="text-center"
                      >
                        <BootstrapTooltip title="Delete Additional Cost">
                          <button
                            type="button"
                            className={`btn btn-icon btn-label-${
                              item.deleteInd ? "warning" : "danger"
                            } btn-md btn-circle mx-1`}
                            onClick={() => {
                              let additionalCost = [];
                              additionalCost = [...values[property]];
                              if (item.ID > 0) {
                                setFieldValue(
                                  `${property}[${index}].deleteInd`,
                                  !item.deleteInd
                                );
                              } else {
                                setItemIndex(0);
                                additionalCost = _.remove(
                                  additionalCost,
                                  function(value, indexArr) {
                                    return index !== indexArr;
                                  }
                                );
                                setFieldValue(property, additionalCost);
                              }
                              calculateTotalPrice(-1, index, !item.deleteInd);
                            }}
                          >
                            {item.deleteInd ? (
                              <i className="fas fa-undo-alt"></i>
                            ) : (
                              <i className="fas fa-trash-alt"></i>
                            )}
                          </button>
                        </BootstrapTooltip>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td className="text-center" colSpan="3">
                    <Illustration
                      guidance="No additional cost"
                      guidanceLeftIcon="fas fa-info-circle kt-font-success"
                    ></Illustration>
                  </td>
                </tr>
              )}
              <tr>
                <td className="text-center py-3" colSpan="4">
                  <button
                    type="button"
                    className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                    onClick={() => {
                      const additionalCost = [...values[property]];
                      additionalCost.push({
                        costComponentID: 0,
                        itemName: "",
                        costPrice: 0,
                        revAccountID: 0,
                        accountName: "",
                        deleteInd: false,
                      });
                      setFieldValue(property, additionalCost);
                    }}
                  >
                    <i className="fas fa-plus-circle"></i>
                    Additional Cost
                  </button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <Table borderless size="sm" responsive="xl">
            <tbody>
              <tr>
                <td style={{ width: "50%" }}>
                  <Typography className="kt-font-bolder">
                    Additional Cost Total
                  </Typography>
                </td>
                <td style={{ width: "0%" }}></td>
                <td style={{ width: "0%" }}></td>
                <td style={{ width: "50%" }}>
                  <Typography component="div" className="kt-font-bolder">
                    <NumberFormat
                      value={values.addCostTotal}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalScale={2}
                      renderText={(value) => (
                        <div className="float-right">
                          {values.currencyCode} {value}
                        </div>
                      )}
                    />
                  </Typography>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Footer>
      </Card>

      <DialogLayout
        open={openSearchCostComp}
        title="Search Cost Component"
        onCloseDialog={() => {
          setOpenSearchCostComp(false);
        }}
        maxWIdth="md"
      >
        <SearchCostComponent
          onSelectCostComponent={(cost) => {
            setFieldValue(`${property}[${itemIndex}].costComponentID`, cost.ID);
            setFieldValue(
              `${property}[${itemIndex}].itemName`,
              cost.costComponentName
            );
            setOpenSearchCostComp(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCostComp(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default SalesAdditionalCost;
